import React, {useEffect, useState} from 'react';
import LazyImage from '../widgets/lazy-image.jsx'

async function decryptImage(uri, key, iv) {
    try {
        const base64data = await window.DecodeImage(uri);
        return base64data;
    } catch (error) {
        console.error('Error decrypting image:', error);
    }
}

const DecodeImage = ({
                         src,
                         alt = '',
                         style = {},
                         className = ''
                     }) => {
    const [decryptedUrl, setDecryptedUrl] = useState(null);

    useEffect(() => {
        if (src) {
            decryptImage(src).then(setDecryptedUrl);
        }
    }, [src]);

    if (!decryptedUrl) {
        return <div style={{width: '100%', textAlign: 'center'}}>Loading image...</div>;
    }

    const whenDone = {
        promise: Promise.resolve({ src: decryptedUrl }),
        cancel: () => {},
    };

    return <LazyImage
        whenDone={whenDone}
        alt={alt} style={style}
    />
};

export default DecodeImage;
